<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12">
    <rect width="16" height="12" rx="1" ry="1" fill="#cbd5e1" />
  </svg>
</template>

<script setup></script>
